import React from "react";
import { GetProps, XStack, YStack } from "tamagui";

import { Label } from "../Typography";
import ErrorLabel from "./ErrorLabel";
import { useFormFieldIds } from "./useFormFieldIds";

export type FormFieldProps = {
  children: React.ReactNode;
  fieldId?: string;
  label?: string;
  labelAccessory?: React.ReactNode;
  errorText?: string;
  rootProps?: GetProps<typeof YStack>;
  labelProps?: GetProps<typeof Label>;
  errorProps?: GetProps<typeof XStack>;
};

export default function FormField({
  children,
  fieldId: id,
  label,
  labelAccessory,
  errorText,
  rootProps,
  labelProps,
  errorProps,
}: FormFieldProps) {
  const { fieldId, labelId, errorId } = useFormFieldIds(id);

  return (
    <YStack {...rootProps}>
      {!!label && (
        <XStack gap="$50" marginBottom="$100" alignItems="center">
          {labelAccessory}
          <Label id={labelId} htmlFor={fieldId} {...labelProps}>
            {label}
          </Label>
        </XStack>
      )}
      {children}
      {errorText && (
        <ErrorLabel id={errorId} marginTop="$50" {...errorProps}>
          {errorText}
        </ErrorLabel>
      )}
    </YStack>
  );
}
